import API from "../api";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allStates: null,
};

const allStateSlice = createSlice({
  name: "allStates",
  initialState,
  reducers: {
    setAllDetailsStates(state, { payload }) {
      state.allStates = payload;
    },
  },
});
export const { setAllDetailsStates } = allStateSlice.actions;
export default allStateSlice.reducer;

//thunks
export const getAllStatesCases = () => async (dispatch) => {
  try {
    const res = await API.get("/confirmed");
    dispatch(setAllDetailsStates(res.data));
  } catch (err) {
    console.log(err.response.data.error);
  }
};
